import axios from 'axios';

let API_URL = `${process.env.REACT_APP_API_URL}/v2/livemeeting`;

export const getCredentials = async (roomName, roleName, userName, userId) => {
  return axios.get(`${API_URL}/session/${roomName}/${userName}/${userId}/${roleName}`);
};

export const getHostCredentials = async (roomName, userName, userId) => {
  return axios.get(`${API_URL}/${roomName}/${userName}/${userId}/host`);
};

export const getGuestCredentials = async (roomName, userName, userId) => {
  return axios.get(`${API_URL}/${roomName}/${userName}/${userId}/guest`);
};

export const getViewerCredentials = async (roomName, userName, userId) => {
  return axios.get(`${API_URL}/${roomName}/${userName}/${userId}/viewer`);
};
